import type { RouteLocationRaw } from 'vue-router'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { cloneDeep, map, mapValues } from 'lodash'
import { visibleSideNavItems } from '@helm/utils/sideNav'
import useMe from '@helm/composables/queries/me'
import type { SideNavLocation } from '@helm/types/sideNav'

const useSideNav = (menu: SideNavLocation) => {
    const route = useRoute()
    const { permissions } = useMe()

    const filterPermissions = computed(() => visibleSideNavItems(menu, permissions.value))

    const sideNav = computed(() =>
        map(filterPermissions.value, item => {
            const routeConfig = cloneDeep(item.route)

            if (typeof routeConfig === 'string') {
                return {
                    ...item,
                    route: {
                        path: routeConfig
                    }
                }
            }

            if (`params` in routeConfig) {
                routeConfig.params = mapValues(routeConfig.params, (value, key) =>
                    `:${key}` === value ? route.params[key] : value
                )

                return {
                    ...item,
                    route: routeConfig
                }
            }

            return item
        })
    )

    const isCurrentRoute = (itemRoute: RouteLocationRaw): boolean => {
        if (typeof itemRoute === `string`) {
            return itemRoute === route?.matched[0].path
        }

        if (`path` in itemRoute) {
            return itemRoute.path === route?.matched[0].path
        }

        if (`name` in itemRoute) {
            return itemRoute.name === route?.matched[0].name
        }

        return false
    }
    const getRouteKey = (itemRoute: RouteLocationRaw): string => {
        if (typeof itemRoute === `string`) {
            return itemRoute
        }

        if (`path` in itemRoute) {
            return itemRoute.path
        }

        if (`name` in itemRoute && typeof itemRoute.name === `string`) {
            return itemRoute.name
        }

        return ``
    }

    return { sideNav, isCurrentRoute, getRouteKey }
}

export default useSideNav
